/**
 * Shared filter-pill vocabulary — MUST stay in sync with
 * `/app/backend/constants/property_types.py`.
 *
 * The Explore filter sheet, the admin booking-override editor, and
 * the traveler card filter-pill badges all read from this file.
 * A newly-added pill here appears in every surface without extra
 * plumbing.  The backend mirror is updated in the same PR for
 * server-side validation of `override.filter_pills`.
 */

export const PROPERTY_TYPES = [
  { id: "hotel",             label: "Hotel" },
  { id: "resort",            label: "Resort" },
  { id: "all_inclusive",     label: "All-Inclusive" },
  { id: "boutique",          label: "Boutique" },
  { id: "bed_and_breakfast", label: "Bed & Breakfast" },
  { id: "villa",             label: "Villa" },
  { id: "cabin",             label: "Cabin" },
  { id: "lodge",             label: "Lodge" },
  { id: "vacation_rental",   label: "Vacation Rental" },
  { id: "hostel",            label: "Hostel" },
  { id: "campground",        label: "Campground" },
  { id: "cruise",            label: "Cruise" },
  { id: "beachfront",        label: "Beachfront" },
  { id: "family",            label: "Family" },
  { id: "adults_only",       label: "Adults-only" },
  { id: "pet_friendly",      label: "Pet-friendly" },
];

export const PROPERTY_TYPE_LABEL_BY_ID = Object.fromEntries(
  PROPERTY_TYPES.map((p) => [p.id, p.label])
);
